module.exports = __webpack_public_path__ + "img/bg.7fd4f764.svg";